import React from 'react'
import 'style/incoming.css'
import CallIcon from '@material-ui/icons/Call';
import CallEndIcon from '@material-ui/icons/CallEnd';

class InComming extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isIncoming: this.props.isIncoming,
      matrixCall: this.props.matrixCall,
      isTalking: this.props.isIncoming,
      profileImage: this.props.profileImage,
      fullname: this.props.userFullname,
      seconds: 0,
      timer: '',
      open: this.props.open || true,
      showTimer: false,
      setIsTalking: this.props.setIsTalking
    }
    console.log('this is call ======================================aa', this.props.matrixCall)
  }

  endCall = async () => {

    this.state.matrixCall.hangup()
    console.log('this is call ==================================,', this.state.matrixCall)
  }

  acceptCall = async () => {
    // this.setState({ showTimer: true })
    // this.startTime()  
    this.state.matrixCall.answer()
  }

  show = () => {
    this.setState({ open: true })
  }

  hide = () => {
    this.setState({ open: false })
  }

  setProfileInfo = (name, avatar) => {
    this.setState({ fullname: name, profileImage: avatar })
  }

  startTime = async () => {
    setInterval(() => {
      this.state.seconds += 1
      this.parseTime(this.state.seconds)
    }, 1000)
  }

  parseTime = async (secs) => {
    const hours = (Math.floor(secs / (60 * 60))).toString();

    const divisor_for_minutes = secs % (60 * 60);
    let minutes = (Math.floor(divisor_for_minutes / 60)).toString();

    const divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = (Math.ceil(divisor_for_seconds)).toString();

    if (minutes.length == 1) minutes = `0${minutes}`
    if (seconds.length == 1) seconds = `0${seconds}`

    let timer = ''
    if (hours > 1) timer += `${hours}:`
    timer += `${minutes}:${seconds}`

    this.setState({ timer })
  }

  render() {
    return (
      this.state.open &&
      <div className='incomingRoot'>
        <div className='incomingContainer'>
          <div className='incomingContainer__text--header'>{this.state.isIncoming ? 'تماس ورودی' : 'در حال تماس'}</div>
          <div className='incomingContainer__profileContainer'>
            <img src={this.state.profileImage || '/images/person.svg'} className='incomingContainer__profile'/>
            <div className='incomingContainer__fullname'>{this.state.fullname}</div>
            {this.state.showTimer ? <div className='incomingContainer__timer'>{this.state.timer}</div> : null}
          </div>
        </div> 
        <div className='callButtonsContainer'>
          {this.state.isTalking && <CallIcon className='callButtonsContainer__accept' onClick={this.props.onClickAcceptCall}/>}
          <CallEndIcon className='callButtonsContainer__end' onClick={this.props.onClickEndCall}/>
        </div>
      </div>
    )
  }
}

export default InComming